import React, { Component } from 'react'
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

export default class Footter extends Component {
    render() {
        return (
            <div>
        <footer className="footer--pin">
        <MDBFooter color="deep-purple darken-2" className="font-small pt-4 mt-4">
          <MDBContainer fluid className="text-center text-md-left">
            <MDBRow>
              <MDBCol md="12">
                <h5 className="title white-text"> Kamphaeng Phet Rajabhat University</h5>
                <p>
                   ระบบคลังหน่วยกิต โดย มหาวิทยาลัยราชภัฏกำแพงเพชร
                </p>
              
              </MDBCol>
            
            </MDBRow>
          </MDBContainer>
          <div className="footer-copyright text-center py-3">
            <MDBContainer fluid>
              &copy; {new Date().getFullYear()} Copyright: <a href="https://www.kpru.ac.th/"> www.kpru.ac.th </a>
            </MDBContainer>
          </div>
        </MDBFooter>
        </footer>
            </div>
        )
    }
}
